export default {
  PerEach: 'perEach',
  Accumulate: 'accumulate',
}
